import React from 'react';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CheckCircleSolidIcon(props) {
  return <FontAwesomeIcon icon={faCheckCircle} {...props} />;
}
